module.exports = __webpack_public_path__ + "assets/webgl/Frame_Painting_normal.1001.a2195b12.jpg";